import Stack from '@admin/components/stack'
import Downloading from './downloading'
import Timestamp from './timestamp'
import PropTypes from 'prop-types'
import React from 'react'

class Picker extends React.Component {

  static propTypes = {
    timestamp: PropTypes.number,
    video: PropTypes.object,
    onBack: PropTypes.func,
    onDone: PropTypes.func
  }

  stackRef = React.createRef()

  _handleDone = this._handleDone.bind(this)
  _handleDownloading = this._handleDownloading.bind(this)

  render() {
    return <Stack { ...this._getStack()} />
  }

  componentDidMount() {
    this._handleTimestamp()
  }

  _getStack() {
    return {
      display_name: 'cover image picker',
      ref: this.stackRef
    }
  }

  _handleDone(keyframe) {
    this.props.onDone(keyframe)
  }

  _handleDownloading(timestamp) {
    const { video } = this.props
    this._handlePush(Downloading, {
      timestamp,
      video,
      onDone: this._handleDone
    })
  }

  _handlePop(index = -1) {
    this.stackRef.current.pop(index)
  }

  _handlePush(component, props) {
    this.stackRef.current.push({ component, props })
  }

  _handleTimestamp() {
    const { timestamp, video, onBack } = this.props
    this._handlePush(Timestamp, {
      timestamp,
      video,
      onBack,
      onDone: this._handleDownloading
    })
  }

}

export default Picker

